var $0128cc194bc107bb$exports = {};
$0128cc194bc107bb$exports = {
    "(optional)": `\u{FF08}\u{53EF}\u{9009}\u{FF09}`,
    "(required)": `\u{FF08}\u{5FC5}\u{586B}\u{FF09}`
};


export {$0128cc194bc107bb$exports as default};
//# sourceMappingURL=zh-CN.module.js.map
